<template>
  <svg viewBox="0 0 64 64">
    <path
      d="M62.5,27.8l-3.1-2.6V62v0.9V64l-11.7,0v0h-7.8c-4.7,0-8.5-4.1-8.5-9.2v-0.3h0h0c0-4.5-1.8-8.8-5-11.7L15.6,33
                l0,3.5c0,0.6-0.4,1-0.9,1c-0.5,0-0.9-0.5-0.9-1v-6c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3l5.4,0c0.5,0,0.9,0.5,0.9,1
                c0,0.6-0.4,1-0.9,1h0l-3.3,0l10.7,9.8c1.6,1.5,2.9,3.3,3.8,5.2v-20L29,29c-0.4,0.4-0.9,0.4-1.3,0c-0.4-0.4-0.4-1,0-1.4l3.9-4.2
                c0.2-0.2,0.4-0.3,0.7-0.3c0.2,0,0.5,0.1,0.7,0.3l3.9,4.2c0.4,0.4,0.4,1,0,1.4c-0.2,0.2-0.4,0.3-0.7,0.3c-0.2,0-0.5-0.1-0.7-0.3
                l-2.3-2.5v19.9c0.9-1.9,2.2-3.7,3.8-5.1l10.7-9.8l-3.3,0h0c-0.5,0-0.9-0.5-0.9-1c0-0.6,0.4-1,0.9-1l5.4,0h0c0.2,0,0.5,0.1,0.7,0.3
                c0.2,0.2,0.3,0.4,0.3,0.7v6c0,0.6-0.4,1-0.9,1c-0.5,0-0.9-0.5-0.9-1l0-3.5l-10.7,9.9c-3.1,2.9-4.9,7-5,11.5v0.5c0,4,3,7.2,6.6,7.2
                h9.9v0l7.8,0V23.8h0.2L32.2,2.5L6.9,23.7V62h19.9c0.5,0,0.9,0.5,0.9,1c0,0.6-0.4,1-0.9,1H6.9H5.1V25.2l-3.7,3.1l-1.1-1.6L32.2,0
                l31.4,26.2L62.5,27.8z"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconLuchtdichtheid extends Vue {}
</script>
